import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";

export default function Personal() {
  const utypes = [
    { value: "Super Admin", label: "Super Admin" },
    { value: "Admin", label: "Admin" },
    { value: "Manager", label: "Manager" },
    { value: "User", label: "User" },
  ];

  return (
    <>
      <Grid container spacing={2} sx={{ mt: 4, px: 2 }}>
        {/* Personal Info */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" align="left">
                Personal Information
              </Typography>
              <Divider sx={{ mt: 2 }} />

              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Name"
                    value="P Kumar"
                    name="name"
                    fullWidth
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Location"
                    value="India"
                    name="location"
                    fullWidth
                    variant="outlined"
                  />
                </Grid>
              </Grid>

              <TextField
                label="Bio"
                multiline
                rows={3}
                fullWidth
                sx={{ mt: 2 }}
                variant="outlined"
              />

              <TextField
                select
                label="User Type"
                name="type"
                value="Super Admin"
                fullWidth
                sx={{ mt: 2 }}
                variant="outlined"
              >
                {utypes.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </CardContent>
          </Card>
        </Grid>

        {/* Contact Info */}
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" align="left">
                Contact Information
              </Typography>
              <Divider sx={{ mt: 2 }} />

              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Contact Phone"
                    value="91999999999"
                    name="phone"
                    type="tel"
                    fullWidth
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Email"
                    value="code@codingmstr.com"
                    name="email"
                    type="email"
                    fullWidth
                    variant="outlined"
                  />
                </Grid>
              </Grid>

              <TextField
                label="Profile URL"
                value="https://codingmstr.com"
                name="url"
                fullWidth
                sx={{ mt: 2 }}
                variant="outlined"
              />

              <TextField
                label="Address"
                multiline
                rows={3}
                fullWidth
                sx={{ mt: 2 }}
                variant="outlined"
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box height={20} />
    </>
  );
}
